import {
  DecisionWorkspace,
  EquationWorkspace,
  EvidenceWorkspace,
  ReadinessWorkspace,
  ReceiptsWorkspace,
  ScenarioWorkspace,
  SourceVaultWorkspace
} from "./WorkspaceViews.jsx";

export function DomainWorkspace({
  activePrimary,
  activeViewId,
  currentDomain,
  receipt,
  selectedOption,
  editableOption,
  setSelectedOptionId,
  updateVariable,
  localLedgerEntries,
  localLedgerSummary
}) {
  if (activePrimary?.id === "source-vault") return <SourceVaultWorkspace />;
  if (activePrimary?.id === "equation-workbench" || activeViewId === "equations") return <EquationWorkspace />;
  if (activeViewId === "scenarios") return <ScenarioWorkspace />;
  if (activePrimary?.id === "receipt-ledger" || activeViewId === "receipts")
    return <ReceiptsWorkspace localLedgerEntries={localLedgerEntries} localLedgerSummary={localLedgerSummary} />;
  if (activePrimary?.id === "release-readiness" || activeViewId === "readiness") return <ReadinessWorkspace />;
  if (activeViewId === "evidence")
    return <EvidenceWorkspace selectedOption={selectedOption} editableOption={editableOption} />;

  return (
    <DecisionWorkspace
      currentDomain={currentDomain}
      receipt={receipt}
      selectedOption={selectedOption}
      editableOption={editableOption}
      setSelectedOptionId={setSelectedOptionId}
      updateVariable={updateVariable}
    />
  );
}
